import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import Select from "react-select";
import { useGetInsuranceConfigListQuery, useGetMyRentCorpQuery } from "@/redux/rentCorpApi";

export const InsuranceConfigPopup = ({ layer = true, onClose, formData, setFormData, onInsuranceConfigSelect }) => {
    const [selectedConfig, setSelectedConfig] = useState(null);
    const [selectedRentCorpId, setSelectedRentCorpId] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");

    // 사업자 리스트 조회
    const { data: myRentCorpData } = useGetMyRentCorpQuery();
    const corpOptions =
        myRentCorpData?.data?.map((item) => ({
            value: item.id,
            label: item.corpName,
        })) || [];

    // 보험 설정 목록 조회
    const { data: insuranceConfigList, refetch } = useGetInsuranceConfigListQuery(selectedRentCorpId, {
        skip: !selectedRentCorpId,
    });

    const handleSearch = () => {
        if (!selectedRentCorpId) {
            setFormData((prev) => ({
                ...prev,
                toastMsg: "사업자를 먼저 선택하세요.",
            }));
            return;
        }
        refetch();
    };

    const handleSelectInsuranceConfig = (config) => {
        if (!config) return;
        setSelectedConfig(config);
    };

    const handleConfirm = () => {
        if (!selectedConfig) {
            setFormData((prev) => ({
                ...prev,
                toastMsg: "보험 설정을 선택하세요.",
            }));
            return;
        }

        // 보험 아이템 처리
        const processedInsuranceItems = (selectedConfig.insuranceConfigItems || []).map((item) => ({
            id: item.id,
            insuranceItemType: item.insuranceItemType,
            joinYn: item.joinYn,
            limitType: item.limitType,
            selfCarDamageRangeType: item.selfCarDamageRangeType,
            selfCarDamageRateType: item.selfCarDamageRateType,
            compensationRange: item.compensationRange,
            selfPay: item.selfPay,
        }));

        setFormData((prev) => ({
            ...prev,
            insuranceConfigId: selectedConfig.id,
            insuranceConfigName: selectedConfig.name,
            selfCarDamageRangeType: selectedConfig.selfCarDamageRangeType,
            selfCarDamageAmount: selectedConfig.selfCarDamageAmount || 0,
            personalInjuryAmount: selectedConfig.personalInjuryAmount || 0,
            propertyDamageAmount: selectedConfig.propertyDamageAmount || 0,
            uninsuredInjuryAmount: selectedConfig.uninsuredInjuryAmount || 0,
            uninsuredPropertyAmount: selectedConfig.uninsuredPropertyAmount || 0,
            insuranceItems: processedInsuranceItems,
        }));

        onInsuranceConfigSelect({
            id: selectedConfig.id,
            rentCorpId: selectedRentCorpId,
        });
        onClose();
    };

    return ReactDOM.createPortal(
        <>
            <div className={layer ? "layer active" : "layer"} onClick={onClose}></div>
            <div className="popup vehicle-list-popup">
                <div className="popup-container">
                    <div className="popup-head">
                        <div className="head-tit">
                            <span className="tit-main">보험 설정 불러오기</span>
                        </div>
                        <div className="btn-close" onClick={onClose}></div>
                    </div>
                    <div className="popup-content">
                        <div className="table-container">
                            <div className="table-filter">
                                <div className="filter-row">
                                    <div className="filter-item">
                                        <div className="item-content">
                                            <div className="item-input">
                                                <Select
                                                    options={corpOptions}
                                                    className="custom-select"
                                                    classNamePrefix="custom-select"
                                                    isSearchable={false}
                                                    placeholder="사업자 선택"
                                                    value={corpOptions.find((opt) => opt.value === selectedRentCorpId)}
                                                    onChange={(option) => setSelectedRentCorpId(option.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* 차량 리스트 */}
                            <div className="table-content">
                                <div className="table-wrapper">
                                    <div className="table">
                                        <table>
                                            <colgroup>
                                                <col width={"12%"} />
                                                <col width={"17%"} />
                                                <col width={"34%"} />
                                                <col width={"17%"} />
                                                <col width={"20%"} />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th>
                                                        <div className="cell">
                                                            <div className="cell-tit">선택</div>
                                                        </div>
                                                    </th>
                                                    <th>
                                                        <div className="cell">
                                                            <div className="cell-tit">보험 설정명</div>
                                                        </div>
                                                    </th>
                                                    <th>
                                                        <div className="cell">
                                                            <div className="cell-tit">설명</div>
                                                        </div>
                                                    </th>
                                                    <th>
                                                        <div className="cell">
                                                            <div className="cell-tit">생성일</div>
                                                        </div>
                                                    </th>
                                                    <th>
                                                        <div className="cell">
                                                            <div className="cell-tit">생성자</div>
                                                        </div>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {insuranceConfigList && insuranceConfigList.data && insuranceConfigList.data.length > 0 ? (
                                                    insuranceConfigList.data.map((config) => (
                                                        <tr key={config.id}>
                                                            <td>
                                                                <div className="cell" style={{ height: "100%" }}>
                                                                    <div className="input-checkbox">
                                                                        <div className="checkbox" style={{ display: "flex" }}>
                                                                            <input
                                                                                type="radio"
                                                                                name="selectedInsuranceConfig"
                                                                                id={`selectedInsuranceConfig-${config.id}`}
                                                                                checked={selectedConfig?.id === config.id}
                                                                                onChange={() => handleSelectInsuranceConfig(config)}
                                                                            />
                                                                            <label htmlFor={`selectedInsuranceConfig-${config.id}`}></label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="cell">
                                                                    <div className="cell-desc">{config.name}</div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="cell">
                                                                    <div className="cell-desc">{config.description}</div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="cell">
                                                                    <div className="cell-desc">{config.createdAt}</div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="cell">
                                                                    <div className="cell-desc">{config.createdBy}</div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="5" className="data-empty">
                                                            <div className="cell" data-align="center">
                                                                <span className="cell-desc">보험 설정 데이터가 없습니다.</span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="popup-bottom">
                        <button type="button" className="btn btn-primary btn-cancel" onClick={onClose}>
                            취소
                        </button>
                        <button type="button" className="btn btn-primary btn-confirm" onClick={handleConfirm} disabled={!selectedConfig}>
                            완료
                        </button>
                    </div>
                </div>
            </div>
        </>,
        document.body
    );
};
